import React from "react"
import { CurrentDotStyle, ProgressDotStyle } from "styles/CarouselProgress.style"

export function ProgressDot() {
    return <div style={ProgressDotStyle} key={`progressDot${Math.random()}`}></div>
};

export function CurrentDot() {
    return <div style={CurrentDotStyle} key='currentDot'></div>
};
